import React, { Component } from 'react';
import axios from 'axios';
import Loader from '../helpers/loader';
import AppContext from '../app/AppContext';
import SocialLoginError from '../helpers/socialLoginError';

class FacebookLogIn extends Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        this.state = {
            hasError: null,
        };
    }

    componentDidMount () {
        const facebookCode = new URLSearchParams(window.location.search).get('code');
        const redirect_uri = `${process.env.REACT_APP_BASE_URL}/facebook-login`;
        const apiCallURL = `${process.env.REACT_APP_API_URL}/api/accounts/auth/login/facebook/`;
        axios
            .post(apiCallURL, {
                code: facebookCode,
                claim: this.context.getClaimId(),
                redirect_uri,
            })
            .then(res => {
                localStorage.removeItem('claim');
                const {
                    membershipStatus,
                    defaultOrganisation,
                } = this.context.getMemberShipStatusAndDefaultOrganisation(res.data.user);
                this.context.setUser(res.data.user);
                if (sessionStorage.getItem('invite_code')) {
                    this.context.acceptTeamInvite(res);
                }
                else {
                    this.context.handleLogInState(res.data.token, membershipStatus, defaultOrganisation);

                    sessionStorage.getItem('next') && this.context.selectedOrganisation?.id ? 
                        this.props.history.push(sessionStorage.getItem('next')) : this.props.history.push('/create-organisation');

                    sessionStorage.removeItem('next');
                }
            })
            .catch(error => {
                console.log('Facebook login error', error.response.data);
                this.setState({
                    hasError: error.response.data.message
                        ? error.response.data.message
                        : 'An error occurred. Please try again later or contact our team at info@racecheck.com.',
                });
            });
    }

    render () {
        return (
            <div>
                {this.state.hasError ? (
                    <SocialLoginError errorMessage={this.state.hasError} />
                ) : (
                    <div className="social-login-loading-container">
                        <Loader />
                        <p>Using Facebook to log you in...</p>
                    </div>
                )}
            </div>
        );
    }
}

export default FacebookLogIn;
